/*--------------(队列)Queue类的定义和测试代码----------------*/
function Queue() {
  this.dataStore = [];
  this.enqueue = enqueue;
  this.dequeue = dequeue;
  this.front = front;
  this.back = back;
  this.culling = culling;
  this.Inquire = Inquire;
  this.toString = toString;
  this.returnArray = returnArray;
  this.empty = empty;
  this.count = count;
}

//入队，就是在数组的末尾添加一个元素
function enqueue(element) {
  this.dataStore.push(element);
}
//出队，就是删除数组的第一个元素
function dequeue() {
  return this.dataStore.shift();
}
//取出数组的第一个元素
function front() {
  return this.dataStore[0];
}
//取出数组的最后一个元素
function back() {
  return this.dataStore[this.dataStore.length - 1];
}
// 剔除中间元素
function culling(index_) {
  return this.dataStore.splice(index_, 1);
}
// 查询下标
function Inquire(attributes_, value_) {
  var arrIndex = -1;
  for (var i = 0; i < this.dataStore.length; i++) {
    if (this.dataStore[i][attributes_] == value_) {
      arrIndex = i;
    }
  }
  return arrIndex;
}
// 数组 转字符串
function toString() {
  var retStr = "";
  for (var i = 0; i < this.dataStore.length; ++i) {
    retStr += this.dataStore[i] + "&nbsp;";
  }
  return retStr;
}
// 返回数组
function returnArray() {
  return this.dataStore;
}
//判断数组是否为空
function empty() {
  if (this.dataStore.length == 0) {
    return true;
  } else {
    return false;
  }
}
//返回数组中元素的个数
function count() {
  return this.dataStore.length;
}

module.exports = Queue;



// WEBPACK FOOTER //
// ./src/components/customerService/queue.js